import { login, getInfo } from "@/api/login";
import {
  getToken,
  setToken,
  removeToken,
  setUserInfo,
  getUserInfo,
} from "@/utils/auth";

const getDefaultState = () => {
  return {
    token: getToken(),
    user_nickname: "",
    avatar: "",
    roles: [],
    user_role: "",
    user_id: "",
    userInfo: {},
  };
};

const state = getDefaultState();

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_SCENIC: (state, storeinfo) => {
    state.storeinfo = storeinfo;
  },
  SET_NAME: (state, user_nickname) => {
    state.user_nickname = user_nickname;
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  SET_USERROLE: (state, role) => {
    state.user_role = role;
  },
  SET_USERID: (state, id) => {
    state.user_id = id;
  },
  SET_USERINFO: (state, userinfo) => {
    state.userInfo = userinfo;
  },
};

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { mobile, password } = userInfo;
    return new Promise((resolve, reject) => {
      login({ mobile: mobile.trim(), password: password })
        .then((response) => {
          if (response.code == 1) {
            const { data } = response;
            commit("SET_TOKEN", data.userinfo.user_token);
            setToken(data.userinfo.user_token);
            setUserInfo(JSON.stringify(data.userinfo));
            resolve(data.userinfo);
          } else {
            resolve(response.msg);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // 初始化APP,获取缓存的token,用户信息等其他缓存内容
  initApp({ commit }) {
    const _userInfo = getUserInfo();
    if (_userInfo) {
      commit("SET_TOKEN", _userInfo.user_token);
      commit("SET_USERINFO", _userInfo);
    }
  },
  // 更新用户信息
  // 修改后（推荐做法：使用对象解构）
  updateUserInfo({ state }, data) {
    if (state.userInfo) {
      state.userInfo = {
        ...state.userInfo,
        ...data,
      };
    } else {
      // 注意：在严格模式下，严禁在 action 中直接修改 state
      // 建议之后在此处调用 commit('SET_USERINFO', data)
      state.userInfo = data;
    }
    setUserInfo(state.userInfo);
  },
  // get user info
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      getInfo()
        .then((response) => {
          const { data } = response;
          if (!data) {
            return reject("验证失败，请重新登录");
          }
          const { user_nickname, avatar, id } = data;
          commit("SET_NAME", user_nickname);
          commit("SET_AVATAR", avatar);
          commit("SET_USERID", id);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  // 退出登录
  logout({ commit }) {
    return new Promise((resolve) => {
      removeToken(); // must remove  token  first
      commit("RESET_STATE");
      resolve();
    });
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      removeToken(); // must remove  token  first
      commit("RESET_STATE");
      resolve();
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
